import * as React from "react";
import ArrowColor from "../../enums/ArrowColor";
import ArrowType from "../../enums/ArrowType";
import webDiplomacyTheme from "../../webDiplomacyTheme";
import { getUnitSize } from "../../map/variants";

const WDArrowMarkerColors = function (
  arrowType: ArrowType,
): React.ReactElement {
  /*
   * 箭头尺寸跟随棋子大小，而不是写死像素：
   * 之前 MOVE 标头用默认的 markerUnits=strokeWidth，8×3.5=28px，
   * 在小棋子地图上几乎和棋子一样大，完全看不清指向。
   * 现在统一用 userSpaceOnUse，标头长度约为棋子边长的 28%
   * （40 的棋子约 11px，经典 75 的棋子约 20px）。
   */
  const unitSize = getUnitSize();
  const head = Math.max(8, Math.min(20, Math.round(unitSize * 0.28)));
  const holdSize = Math.max(45, Math.min(90, Math.round(unitSize * 1.2)));

  switch (arrowType) {
    case ArrowType.SUPPORT:
      return (
        <>
          {Object.entries(webDiplomacyTheme.palette.arrowColors).map(
            ([arrowColor, config]) => (
              <marker
                id={`arrowHead__${ArrowType[arrowType]}_${ArrowColor[arrowColor]}`}
                key={`arrowHead__${ArrowType[arrowType]}_${ArrowColor[arrowColor]}`}
                markerWidth={Math.round(head * 1.3)}
                markerHeight={Math.round(head * 0.8)}
                markerUnits="userSpaceOnUse"
                viewBox="0 0 10 6"
                refX={9.4}
                refY={3}
                orient="auto"
              >
                <polygon
                  points="0 0, 6 3, 0 6, 0 5, 4 3, 0 1"
                  fill={config.main}
                />
                <polygon
                  points="4 0, 10 3, 4 6, 4 5, 8 3, 4 1"
                  fill={config.main}
                />
              </marker>
            ),
          )}
        </>
      );
    case ArrowType.HOLD:
      return (
        <>
          {Object.entries(webDiplomacyTheme.palette.arrowColors).map(
            ([arrowColor, config]) => (
              <marker
                id={`arrowHead__${ArrowType[arrowType]}_${ArrowColor[arrowColor]}`}
                key={`arrowHead__${ArrowType[arrowType]}_${ArrowColor[arrowColor]}`}
                markerWidth={holdSize}
                markerHeight={holdSize}
                markerUnits="userSpaceOnUse"
                viewBox="0 0 90 90"
                refX={10}
                refY={45}
                orient="auto"
                strokeWidth={4}
              >
                <path d=" M 24 72 A 30 30 180 0 1 24 18" stroke={config.main} />
              </marker>
            ),
          )}
        </>
      );
    default:
      return (
        <>
          {Object.entries(webDiplomacyTheme.palette.arrowColors).map(
            ([arrowColor, config]) => (
              <marker
                id={`arrowHead__${ArrowType[arrowType]}_${ArrowColor[arrowColor]}`}
                key={`arrowHead__${ArrowType[arrowType]}_${ArrowColor[arrowColor]}`}
                markerWidth={head}
                markerHeight={head}
                markerUnits="userSpaceOnUse"
                viewBox="0 0 8 8"
                refX={
                  (arrowColor as unknown as number) ===
                  ArrowColor.IMPLIED_FOREIGN
                    ? 0
                    : 7.4
                }
                refY={4}
                orient="auto"
              >
                <polygon points="0 0, 8 4, 0 8" fill={config.main} />
              </marker>
            ),
          )}
        </>
      );
  }
};

const WDArrowMarkerDefs = function (): React.ReactElement {
  return (
    <>
      {WDArrowMarkerColors(ArrowType.HOLD)}
      {WDArrowMarkerColors(ArrowType.MOVE)}
      {WDArrowMarkerColors(ArrowType.SUPPORT)}
    </>
  );
};

export default WDArrowMarkerDefs;
